import * as React from "react";
import { List, Datagrid, TextField, DateField, ShowButton, TopToolbar } from 'react-admin';
import MyDatagridHeader from '../../components/MyDatagridHeader';

const OrderList = () => (
    <List
        actions={<TopToolbar />}
        sort={{ field: 'start_date', order: 'ASC' }}
        sx={{
            "& .MuiPaper-root": {
                overflow: { xs: 'scroll', md: 'auto' },
                width: { xs: '100vw', md: '100%' }
            },
        }}
        storeKey={false}
    >
        <Datagrid header={<MyDatagridHeader />} bulkActionButtons={false}>
            <TextField source="name" label="Name" />
            <DateField source="start_date" label="Start date" locales="en-GB" />
            <DateField source="end_date" label="End date" locales="en-GB" />
            <ShowButton />
            <DateField showTime options={{ hour12: false }} source="updated_at" locales="en-GB" label="Updated at" />
        </Datagrid>
    </List>
);

export default OrderList;
